export default "__VITE_ASSET__cee9883f__"